import React from 'react';
import Heading from '../Typography/Heading';
import SpecialText from '../Typography/SpecialText';
import {
  PUBLIC_ABOUT_BANNER_TOP_CLASS,
  PUBLIC_HERO_TO_SECTION_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from '../../../sections/Public/shared/publicLayoutSpec';

const AboutUsBanner = ({ heading, className, children, headingClasses }) => {
  // You can add AboutUs-specific logic or styles here
  return (
    <>
    <div className={`tp-container px-10 ${PUBLIC_ABOUT_BANNER_TOP_CLASS} ${PUBLIC_HERO_TO_SECTION_CLASS} max-w-[1905px] mx-auto`}>
      <div className={`${className} w-[100%] h-screen relative rounded-xl bg-no-repeat bg-center object-cover bg-cover`}> 
        <div className="mx-[5%] xl:mx-auto xl:w-[1100px] h-full text-center flex flex-col items-center justify-center">
          <Heading variant={"h1"} className={`${headingClasses} text-center`}>
            {heading}
          </Heading>

            <SpecialText variant={"IntroParagraph"} className={`text-white !capitalize ${PUBLIC_HEADING_TO_CONTENT_CLASS} max-w-3xl mx-auto`}>
                No middlemen. No commissions. No taskers. Just real trade businesses, ready to work.
            </SpecialText>
        </div>
      </div>
      </div>
    </>
  );
};

export default AboutUsBanner;